module.exports = __webpack_public_path__ + "img/minting-bg.cf581f2b.png";